import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { FOLLOW_REPLY_CHANNEL } from 'apps/followReply/constants'
import { FollowReplyState } from 'apps/followReply/interfaces'
import { getChannelState, NAMESPACE } from 'apps/followReply/store/constants'
import { followReplyApi } from 'shared/api/requests/followReply'
import { createAsyncAction } from 'shared/lib/redux'

export const setFlow = createAsyncAction(`${NAMESPACE}/setFlow`, async (flowId: string) => {
  const replacedFlowData = await followReplyApi.replaceFlow({
    body: { flow_ns: flowId },
  })

  return replacedFlowData.data
})

export const setFlowReducer = (builder: ActionReducerMapBuilder<FollowReplyState>) => {
  builder.addCase(setFlow.fulfilled, (state, action) => {
    const data = action.payload
    state[FOLLOW_REPLY_CHANNEL] = getChannelState(data)
  })
}
